/** @jsxImportSource @emotion/react */
import { jsx } from '@emotion/react/macro'
import { AlertEvent } from 'lib/types'
import { AlertChatEvent } from './AlertChatEvent'

export const AlertChatEvents = ({ events }: { events: AlertEvent[] }) => {
  return (
    <>
      {events.map((event: any, index: number) => (
        <AlertChatEvent key={`event-${index}`} event={event} />
      ))}
    </>
  )
}
